import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { format, subDays } from "date-fns";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import MetricTrend from "../metrics/metric-trend";
import MetricValue from "../metrics/metric-value";
import { getTrendLabels, getLabels } from "../../../helpers/metrics";
import { useApiTenant } from "../../../api/api-tenant";
export default function UsersMetrics() {
    const { t } = useTranslation();
    const api = useApiTenant();
    const [usersValue, setUsersValue] = useState(0);
    const [usersValueRange, setUsersValuesRange] = useState("total");
    const [usersValueLoading, setUsersValueLoading] = useState(true);
    const [usersValueError, setUsersValueError] = useState(false);
    const [usersValueCachedAt, setUsersValueCachedAt] = useState("");
    const [usersValueStartDate, setUsersValueStartDate] = useState("");
    const [usersValueEndDate, setUsersValueEndDate] = useState("");
    const [usersValueStartTime, setUsersValueStartTime] = useState("");
    const [usersValueEndTime, setUsersValueEndTime] = useState("");
    const [isChosenValueCustomRange, setIsChosenValueCustomRange] = useState(false);
    const [usersTrendLabels, setUsersTrendLabels] = useState([]);
    const [usersTrendValues, setUsersTrendValues] = useState([]);
    const [usersTrendCachedAt, setUsersTrendCachedAt] = useState("");
    const [usersTrendRange, setUsersTrendRange] = useState("last_30_days");
    const [usersTrendLoading, setUsersTrendLoading] = useState(true);
    const [usersTrendError, setUsersTrendError] = useState(false);
    const [usersRolesData, setUsersRolesData] = useState([]);
    const [usersRolesCachedAt, setUsersRolesCachedAt] = useState("");
    const [userRolesRange, setRolesRange] = useState("total");
    const [usersRolesLoading, setUsersRolesLoading] = useState(true);
    const [usersRolesError, setUsersRolesError] = useState(false);
    const [usersRolesStartDate, setUsersRolesStartDate] = useState("");
    const [usersRolesEndDate, setUsersRolesEndDate] = useState("");
    const [usersRolesStartTime, setUsersRolesStartTime] = useState("");
    const [usersRolesEndTime, setUsersRolesEndTime] = useState("");
    const [isChosenRolesCustomRange, setIsChosenRolesCustomRange] = useState(false);
    const [usersValueMetricsRefresh, setUsersValueMetricsRefresh] = useState(false);
    const [usersTrendMetricsRefresh, setUsersTrendMetricsRefresh] = useState(false);
    const [usersRolesMetricsRefresh, setUsersRolesMetricsRefresh] = useState(false);
    const getUsersValue = invalidateCache => {
        setUsersValueLoading(true);
        if (usersValueError)
            setUsersValueError(false);
        let startTime;
        let endTime;
        if (usersValueRange === "custom" &&
            usersValueStartDate !== "" &&
            usersValueEndDate !== "") {
            if (usersValueStartTime !== "") {
                startTime =
                    format(new Date(usersValueStartDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(usersValueStartTime), "HH:mm:ss");
            }
            else {
                startTime = format(new Date(usersValueStartDate), "yyyy-MM-dd") + " 00:00:00";
            }
            if (usersValueEndTime !== "") {
                endTime =
                    format(new Date(usersValueEndDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(usersValueEndTime), "HH:mm:ss");
            }
            else {
                endTime = format(new Date(usersValueEndDate), "yyyy-MM-dd") + " 23:59:59";
            }
        }
        api.GET_metrics("count", "tenant_users", usersValueRange, undefined, undefined, undefined, undefined, undefined, invalidateCache ? 1 : undefined, usersValueRange === "custom" ? startTime : undefined, usersValueRange === "custom" ? endTime : undefined)
            .then(response => {
            setUsersValue(response.data.count);
            setUsersValueCachedAt(response.data.cached_at);
            setUsersValueLoading(false);
        })
            .catch(error => {
            setUsersValueError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setUsersValueLoading(false);
            }
        });
        return () => api.cancel();
    };
    const getUsersRolesValues = invalidateCache => {
        setUsersRolesLoading(true);
        if (usersRolesError)
            setUsersRolesError(false);
        let startTime;
        let endTime;
        if (userRolesRange === "custom" && usersRolesStartDate !== "" && usersRolesEndDate !== "") {
            if (usersRolesStartTime !== "") {
                startTime =
                    format(new Date(usersRolesStartDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(usersRolesStartTime), "HH:mm:ss");
            }
            else {
                startTime = format(new Date(usersRolesStartDate), "yyyy-MM-dd") + " 00:00:00";
            }
            if (usersRolesEndTime !== "") {
                endTime =
                    format(new Date(usersRolesEndDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(usersRolesEndTime), "HH:mm:ss");
            }
            else {
                endTime = format(new Date(usersRolesEndDate), "yyyy-MM-dd") + " 23:59:59";
            }
        }
        api.GET_metrics("partition", "tenant_users", userRolesRange, "roles", undefined, undefined, undefined, undefined, invalidateCache ? 1 : undefined, userRolesRange === "custom" ? startTime : undefined, userRolesRange === "custom" ? endTime : undefined)
            .then(response => {
            let metricsData = [];
            response.data.data.map(a => {
                let color;
                if (a.label === "Agent") {
                    color = "33, 150, 243";
                }
                if (a.label === "Manager") {
                    color = "251, 152, 0";
                }
                if (a.label === "Admin") {
                    color = "244, 67, 54";
                }
                metricsData.push({ label: a.label, count: a.count, color: color });
            });
            setUsersRolesData(metricsData
                .sort(function (a, b) {
                return a.count - b.count;
            })
                .reverse());
            setUsersRolesCachedAt(response.data.cached_at);
            setUsersRolesLoading(false);
        })
            .catch(error => {
            setUsersRolesError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setUsersRolesLoading(false);
            }
        });
        return () => api.cancel();
    };
    const getUsersTrendValues = invalidateCache => {
        setUsersTrendLoading(true);
        if (usersTrendError)
            setUsersTrendError(false);
        let trendsLabels = getTrendLabels(usersTrendRange);
        let labels = getLabels(trendsLabels, usersTrendRange);
        setUsersTrendLabels(labels);
        let interval = usersTrendRange;
        let startDate;
        let endDate;
        if (usersTrendRange === "last_7_days") {
            interval = "custom";
            startDate = format(subDays(new Date(), 6), "yyyy-MM-dd") + " 00:00:00";
            endDate = format(new Date(), "yyyy-MM-dd") + " 23:59:59";
        }
        else if (usersTrendRange === "last_30_days") {
            interval = "custom";
            startDate = format(subDays(new Date(), 29), "yyyy-MM-dd") + " 00:00:00";
            endDate = format(new Date(), "yyyy-MM-dd") + " 23:59:59";
        }
        api.GET_metrics("trend", "tenant_users", interval, undefined, undefined, undefined, undefined, undefined, invalidateCache ? 1 : undefined, startDate, endDate)
            .then(response => {
            let values = [];
            trendsLabels.map(label => {
                if (response.data.data.find(a => a.date === label)) {
                    values.push(response.data.data.find(a => a.date === label).count);
                }
                else {
                    values.push(0);
                }
            });
            setUsersTrendCachedAt(response.data.cached_at);
            setUsersTrendValues(values);
            setUsersTrendLoading(false);
        })
            .catch(error => {
            setUsersTrendError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setUsersTrendLoading(false);
            }
        });
        return () => api.cancel();
    };
    useEffect(() => {
        if (usersValueRange !== "custom") {
            setUsersValueStartDate("");
            setUsersValueEndDate("");
            setUsersValueStartTime("");
            setUsersValueEndTime("");
            getUsersValue(undefined);
        }
    }, [usersValueRange]);
    useEffect(() => {
        if (isChosenValueCustomRange && usersValueStartDate !== "" && usersValueEndDate !== "") {
            getUsersValue(undefined);
        }
    }, [isChosenValueCustomRange]);
    useEffect(() => {
        if (userRolesRange !== "custom") {
            setUsersValueStartDate("");
            setUsersValueEndDate("");
            setUsersValueStartTime("");
            setUsersValueEndTime("");
            getUsersRolesValues(undefined);
        }
    }, [userRolesRange]);
    // useEffect(() => {
    //     if (isChosenRolesCustomRange && usersRolesStartDate !== "" && usersRolesEndDate !== "") {
    //         getUsersRolesValues(undefined)
    //     }
    // }, [isChosenRolesCustomRange])
    useEffect(() => {
        getUsersTrendValues(undefined);
    }, [usersTrendRange]);
    useEffect(() => {
        if (usersTrendMetricsRefresh) {
            getUsersTrendValues(true);
            setUsersTrendMetricsRefresh(false);
        }
        if (usersValueMetricsRefresh) {
            getUsersValue(true);
            setUsersValueMetricsRefresh(false);
        }
        if (usersRolesMetricsRefresh) {
            getUsersRolesValues(true);
            setUsersRolesMetricsRefresh(false);
        }
    }, [usersValueMetricsRefresh, usersRolesMetricsRefresh, usersTrendMetricsRefresh]);
    return (_jsx(Box, Object.assign({ sx: {
            marginBottom: 4,
        } }, { children: _jsxs(Grid, Object.assign({ container: true, spacing: 4 }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12, md: 5, xl: 4 }, { children: _jsx(MetricValue, { title: t("users.users"), value: usersValue, range: usersValueRange, setRange: setUsersValuesRange, isLoading: usersValueLoading, setIsLoading: setUsersValueLoading, cachedAt: usersValueCachedAt, refresh: usersValueMetricsRefresh, setRefresh: setUsersValueMetricsRefresh, startDate: usersValueStartDate, setStartDate: setUsersValueStartDate, endDate: usersValueEndDate, setEndDate: setUsersValueEndDate, startTime: usersValueStartTime, setStartTime: setUsersValueStartTime, endTime: usersValueEndTime, setEndTime: setUsersValueEndTime, setIsChosenCustomRange: setIsChosenValueCustomRange, isError: usersValueError }) })), _jsx(Grid, Object.assign({ item: true, xs: 12, md: 7, xl: 8 }, { children: _jsx(MetricTrend, { title: t("users.metrics.users-trend"), label: t("users.users"), labels: usersTrendLabels, values: usersTrendValues, range: usersTrendRange, setRange: setUsersTrendRange, isLoading: usersTrendLoading, setIsLoading: setUsersTrendLoading, cachedAt: usersTrendCachedAt, refresh: usersTrendMetricsRefresh, setRefresh: setUsersTrendMetricsRefresh, isError: usersTrendError }) }))] })) })));
}
